module.exports = __webpack_public_path__ + "media/images/insights/carbon-footprint-review-copies-fig-1-d61394ae95cf1e2c816f8b3f46b9a011.jpg";